{
  "environment": "prod",
  "apiBaseUrl": "https://api.opncue.com",
  "socketUrl": "https://api.opncue.com",
  "webBaseUrl": "https://web.opncue.com",
  "useMock": false,
  "app": {
    "name": "opncue",
    "scheme": "opncue",
    "oauthRedirectScheme": "com.opncue.app",
    "oauthRedirectPath": "oauthredirect"
  },
  "oauth": {
    "googleWebClientId": "470847590923-st70c4lf528804lqhj3s0q133nln4iae.apps.googleusercontent.com",
    "googleIosClientId": "470847590923-us0u46266573f7iebnblu5amkolio08j.apps.googleusercontent.com",
    "googleAndroidClientId": "470847590923-hcc4r2dc7c45s5kkifh6mcl07skmqt9b.apps.googleusercontent.com",
    "appleBundleIds": [
      "com.opncue.app",
      "com.opncue.web"
    ],
    "appleWebClientId": "com.opncue.web",
    "appleWebRedirectUri": "https://web.opncue.com/oauth/apple/callback"
  },
  "stripe": {
    "publishableKey": "pk_live_51TqwT37TD5E7wZBudlmJIOocefqOQBpWhptA7FA9PqCMzODJDeeEvTVz2j1K0OGR9DTUYek2sFvKf5WDgWrXWfbJ00VYvsX9WB"
  },
  "revenuecat": {
    "iosPublicSdkKey": "appl_GlroVZNUYleBWETUwdyMWogxlSh",
    "androidPublicSdkKey": "goog_ZUMsuMVkhcSuBjuaCUcaJajyOoQ"
  },
  "sentry": {
    "enabled": true,
    "tracesSampleRate": 0,
    "mobile": {
      "dsn": "https://bcd8912cb2a12819cfbe39f48579174d@o4511856579969024.ingest.de.sentry.io/4511856814129232"
    },
    "web": {
      "dsn": "https://1614717e36b126b61ab563c09a378e80@o4511856579969024.ingest.de.sentry.io/4511856820879440"
    }
  },
  "verification": {
    "codeExpiryMinutes": 10,
    "resendCooldownSeconds": 60
  },
  "features": {
    "conversationPractice": true,
    "nearbyDiscovery": true,
    "voicePractice": true
  },
  "locales": {
    "supported": [
      "en",
      "es-ES",
      "es-419",
      "pt-BR",
      "pt-PT",
      "fr-FR",
      "fr-CA"
    ],
    "default": "en"
  },
  "location": {
    "nearbyUserCloseByRadiusMeters": 500,
    "nearbyUserRadiusMeters": 5000,
    "nearbyUserLocalAreaRadiusMeters": 10000,
    "venueSearchRadiusMeters": 1000,
    "venueJoinRadiusMeters": 200,
    "venueJoinDistanceMeters": 100
  }
}
